(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-motiv-check"] && !Shopify.designMode) return;
  try {
    function fsAssessResolution(width, height, title) {
    const matches = [...String(title).matchAll(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm\b/gi)];
    if (matches.length !== 1 || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
    const cmWidth = Number(matches[0][1].replace(',', '.'));
    const cmHeight = Number(matches[0][2].replace(',', '.'));
    if (cmWidth <= 0 || cmHeight <= 0) return null;
    const ppi = Math.min(width * 2.54 / cmWidth, height * 2.54 / cmHeight);
    return { width, height, cmWidth, cmHeight, ppi, enough: ppi >= 150,
      ratioMismatch: Math.abs((width / height) / (cmWidth / cmHeight) - 1) > 0.05,
      requiredWidth: Math.ceil(cmWidth / 2.54 * 150), requiredHeight: Math.ceil(cmHeight / 2.54 * 150) };
  }

  if (!customElements.get('fs-motiv-check')) {
    customElements.define('fs-motiv-check', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.sequence = (this.sequence || 0) + 1;
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.templates = JSON.parse(this.querySelector('[data-template-map]').textContent)[this.dataset.handle] || [];
        this.templateLink = this.querySelector('[data-template-link]');
        this.allTemplatesHref = this.templateLink.getAttribute('href');
        this.updateTemplateLink(this.variants[this.dataset.variantId]);
        this.input = this.querySelector('input[type="file"]');
        this.result = this.querySelector('[role="status"]');
        this.orderCheck = this.querySelector('[data-order-check]');
        this.assistance = this.querySelector('[data-assistance]');
        this.helpRequest = this.querySelector('[data-help-request]');
        this.helpNotes = this.querySelector('[data-help-notes]');
        this.helpDetails = this.querySelector('[data-help-details]');
        this.replaceHint = this.querySelector('[data-replace-hint]');
        const opts = { signal: this.controller.signal };
        this.input.addEventListener('change', () => { this.activeSource = 'local'; this.orderCheck.disabled = true; this.uploadFetch?.abort(); this.readFile(); }, opts);
        this.parentSection = document.getElementById('shopify-section-' + this.dataset.sectionId);
        this.helpRequest.addEventListener('change', () => this.syncAssistance(), opts);
        this.querySelector('[data-replace-upload]').addEventListener('click', () => {
          const button = this.parentSection?.querySelector('[data-ph-fieldname="Produktupload"] .uploadcare--widget_status_loaded .uploadcare--widget__file-name') || this.parentSection?.querySelector('[data-ph-fieldname="Produktupload"] .uploadcare--widget__button_type_open');
          this.replaceHint.hidden = Boolean(button);
          if (button) { button.focus(); button.click(); }
        }, opts);
        this.parentSection?.addEventListener('variant:change', (event) => {
          if (event.detail?.variant?.id) this.dataset.variantId = String(event.detail.variant.id);
          this.updateTemplateLink(this.variants[this.dataset.variantId]);
          this.resetAfterVariantChange();
        }, opts);
        this.parentSection?.addEventListener('change', (event) => {
          if (event.target === this.input) return;
          if (event.target?.name === 'id' && this.variants[event.target.value]) this.dataset.variantId = event.target.value;
          if (event.target?.matches('select, input[type="radio"], input[name="id"]')) this.resetAfterVariantChange();
        }, opts);
        const removeSelection = event => {
          const button = event.target.closest('[data-fs-remove]');
          if (!button || (event.type === 'keydown' && !['Enter', ' '].includes(event.key))) return;
          const preview = button.closest('[id^="previewImages_"]');
          const fieldId = preview?.id.slice('previewImages_'.length);
          const config = window.UPLOADCARE_DATA?.[fieldId];
          if (!config?.widget || preview.children.length !== 1) return;
          event.preventDefault(); event.stopImmediatePropagation();
          config.widget.value(null);
          document.querySelectorAll('[data-img-id][id*="imageFiles_' + fieldId + '"]').forEach(element => element.remove());
          preview.replaceChildren();
          preview.style.marginBottom = '0';
          const uploadButton = document.getElementById('selBtn_' + fieldId)?.querySelector('.uploadcare--widget__button_type_open');
          if (uploadButton) uploadButton.textContent = config.uploadButtonText || this.messages.choose;
          this.scanUploadedFile(true);
        };
        this.parentSection?.addEventListener('click', removeSelection, { ...opts, capture: true });
        this.parentSection?.addEventListener('keydown', removeSelection, { ...opts, capture: true });
        this.uploadObserver?.disconnect();
        if (this.parentSection) {
          this.uploadObserver = new MutationObserver(() => {
            clearTimeout(this.uploadScanTimer);
            this.uploadScanTimer = setTimeout(() => this.scanUploadedFile(), 100);
          });
          this.uploadObserver.observe(this.parentSection, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cdn', 'value'] });
          this.scanUploadedFile();
        }
      }

      async scanUploadedFile(force = false) {
        this.parentSection.querySelectorAll('[id^="previewImages_"] [title^="Remove "]:not([data-fs-remove])').forEach(button => {
          button.dataset.fsRemove = 'true';
          button.textContent = this.messages.remove;
          button.setAttribute('role', 'button');
          button.setAttribute('tabindex', '0');
          button.setAttribute('aria-label', this.messages.remove);
        });
        const urls = [...new Set([...this.parentSection.querySelectorAll('input[name="properties[Produktupload]"][data-cdn]')].map(input => input.value ? input.getAttribute('data-cdn') : '').filter(Boolean))];
        const url = urls.length === 1 ? urls[0] : '';
        if (url === (this.lastUploadURL || '') && !force) return;
        if (url !== (this.lastUploadURL || '')) {
          this.helpRequest.checked = false;
          this.helpNotes.value = '';
          this.replaceHint.hidden = true;
        }
        this.lastUploadURL = url;
        this.syncAssistance();
        this.uploadFetch?.abort();
        if (!url) {
          this.cachedUpload = null;
          if (this.activeSource === 'upload') { this.sequence++; this.dimensions = null; this.say('idle', [this.messages.idle]); }
          return;
        }
        this.activeSource = 'upload';
        this.sequence++;
        this.dimensions = null;
        let parsed;
        try { parsed = new URL(url); } catch { this.say('manual', [this.messages.upload_error]); return; }
        if (parsed.protocol !== 'https:' || parsed.hostname !== '4gerljexqx.ucarecd.net') { this.say('manual', [this.messages.upload_error]); return; }
        this.input.value = '';
        this.querySelector('details').open = true;
        if (this.cachedUpload?.url === url) { this.readFile(this.cachedUpload.blob); return; }
        const sequence = ++this.sequence;
        this.dimensions = null;
        this.say('reading', [this.messages.reading]);
        const controller = new AbortController();
        this.uploadFetch = controller;
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
          if (sequence !== this.sequence || !this.isConnected) return;
          if (!response.ok) throw new Error('file unavailable');
          if (Number(response.headers.get('content-length')) > 40 * 1024 * 1024) { this.say('manual', [this.messages.large]); return; }
          if (!/^image\/(png|jpeg|webp)(?:;|$)/i.test(response.headers.get('content-type') || '')) { this.say('manual', [this.messages.upload_manual]); return; }
          const blob = await response.blob();
          if (sequence !== this.sequence || !this.isConnected) return;
          this.cachedUpload = { url, blob };
          this.readFile(blob);
        } catch {
          if (sequence === this.sequence && this.isConnected) this.say('manual', [this.messages.upload_error]);
        } finally { clearTimeout(timeout); }
      }

      updateTemplateLink(title) {
        const dimensions = fsAssessResolution(1, 1, title);
        const matches = this.templates.filter(t => dimensions && t.width === dimensions.cmWidth && t.height === dimensions.cmHeight && (t.edition === 'RECHTECK' || String(title).toUpperCase().includes(t.edition)));
        const template = matches.length === 1 ? matches[0] : null;
        this.templateLink.href = template ? template.url : this.allTemplatesHref;
        this.templateLink.textContent = template ? this.format('template', { edition: template.edition, size: template.size, width: template.width, height: template.height }) : this.messages.templates_all;
        if (template) { this.templateLink.target = '_blank'; this.templateLink.rel = 'noopener'; }
        else { this.templateLink.removeAttribute('target'); this.templateLink.removeAttribute('rel'); }
      }

      resetAfterVariantChange() {
        if (this.activeSource === 'upload' && this.lastUploadURL) { this.sequence++; this.dimensions = null; this.say('reading', [this.messages.reading]); this.scanUploadedFile(true); return; }
        if (!this.input.files?.length && !this.dimensions) return;
        this.sequence++;
        this.dimensions = null;
        this.input.value = '';
        this.say('idle', [this.messages.changed]);
      }

      disconnectedCallback() {
        this.uploadObserver?.disconnect();
        this.uploadFetch?.abort();
        clearTimeout(this.uploadScanTimer);
        this.controller?.abort();
        this.sequence++;
      }

      syncAssistance() {
        const hasUpload = this.activeSource === 'upload' && Boolean(this.lastUploadURL);
        if (!hasUpload) this.helpRequest.checked = false;
        const needsHelp = ['low', 'manual'].includes(this.result.dataset.state);
        this.helpRequest.disabled = !hasUpload;
        const requested = hasUpload && this.helpRequest.checked;
        this.assistance.hidden = !(hasUpload && (needsHelp || requested));
        this.helpDetails.hidden = !requested;
        this.helpNotes.disabled = !requested;
        if (!requested) this.helpNotes.value = '';
      }

      say(state, paragraphs) {
        this.orderCheck.disabled = !(this.activeSource === 'upload' && this.lastUploadURL);
        this.orderCheck.value = this.messages['order_' + state] || this.messages.order_manual;
        this.result.dataset.state = state;
        this.syncAssistance();
        this.result.replaceChildren(...paragraphs.map(text => {
          const p = document.createElement('p'); p.textContent = text; return p;
        }));
      }

      format(key, values) {
        return this.messages[key].replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
      }

      currentTitle() {
        const form = document.getElementById('product-form-' + this.dataset.productId + '-' + this.dataset.sectionId);
        const id = form?.elements.namedItem('id')?.value;
        return this.variants[id] || this.variants[this.dataset.variantId] || '';
      }

      showImageResult() {
        if (!this.dimensions) return;
        const assessment = fsAssessResolution(this.dimensions.width, this.dimensions.height, this.currentTitle());
        if (!assessment) { this.say('manual', [this.messages.unknown]); return; }
        const a = assessment;
        const paragraphs = [this.format('detail', { ...a, ppi: new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { maximumFractionDigits: 1 }).format(Math.floor(a.ppi * 10) / 10) }), this.messages[a.enough ? 'enough' : 'low']];
        if (a.ratioMismatch) paragraphs.push(this.messages.ratio);
        paragraphs.push(this.format('requirement', { width: a.requiredWidth, height: a.requiredHeight }));
        this.say(a.enough ? 'enough' : 'low', paragraphs);
      }

      async readFile(uploadedBlob) {
        const sequence = ++this.sequence;
        this.dimensions = null;
        const file = uploadedBlob || this.input.files?.[0];
        if (!file) { this.say('idle', [this.messages.idle]); return; }
        if (file.size > 40 * 1024 * 1024) { this.say('manual', [this.messages.large]); return; }
        let signature;
        try { signature = new Uint8Array(await file.slice(0, 12).arrayBuffer()); }
        catch {
          if (sequence === this.sequence && this.isConnected) this.say('manual', [this.messages.error]);
          return;
        }
        if (sequence !== this.sequence || !this.isConnected) return;
        const png = [137,80,78,71,13,10,26,10].every((v,i) => signature[i] === v);
        const jpeg = signature[0] === 255 && signature[1] === 216 && signature[2] === 255;
        const webp = String.fromCharCode(...signature.slice(0,4)) === 'RIFF' && String.fromCharCode(...signature.slice(8,12)) === 'WEBP';
        if (!png && !jpeg && !webp) { this.say('manual', [this.messages.manual]); return; }
        this.say('reading', [this.messages.reading]);
        let timeout;
        try {
          const dimensions = await Promise.race([
            createImageBitmap(file).then(bitmap => {
              const result = { width: bitmap.width, height: bitmap.height }; bitmap.close(); return result;
            }),
            new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('timeout')), 10000); })
          ]);
          if (sequence !== this.sequence || !this.isConnected) return;
          this.dimensions = dimensions;
          this.showImageResult();
        } catch {
          if (sequence === this.sequence && this.isConnected) this.say('manual', [this.messages.error]);
        } finally { clearTimeout(timeout); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
